<ng-container>
  <ng-template appHost></ng-template>
</ng-container>
